export default "__VITE_ASSET__CFXrDL8y__"